import type { LanguageCode } from "./language.model";

export type TranslationParams = Record<string, string | number>;

export const translations = {
  en: {
    "language.label": "Language",
    "language.en": "English",
    "language.pt": "Portuguese",
    "language.nl": "Dutch",
    "language.sv": "Swedish",
    "common.points": "Points",
    "common.pointsShort": "pts",
    "common.completed": "Completed",
    "common.current": "Current",
    "common.locked": "Locked",
    "common.cancel": "Cancel",
    "common.backToMap": "Back to Map",
    "common.returnToMap": "Return to Map",
    "common.settings": "Settings",
    "common.signOut": "Sign Out",
    "common.zoomIn": "Zoom In",
    "common.zoomOut": "Zoom Out",
    "common.resetView": "Reset View",
    "common.level": "Level",
    "brand.fullName": "LOGISTIC INTELLIGENCE NAVIGATOR FOR AI ADOPTION",
    "chat.open": "Open chat",
    "chat.dragPanel": "Drag chat",
    "chat.minimize": "Minimize chat",
    "chat.close": "Close chat",
    "chat.statusOnline": "Online",
    "chat.statusOffline": "Offline",
    "chat.goOnline": "Go online",
    "chat.goOffline": "Go offline",
    "chat.title": "Direct messages",
    "chat.online": "Online",
    "chat.onlineCount": "Online: {count}",
    "chat.offline": "Offline",
    "chat.statusCount": "{online} online / {offline} offline",
    "chat.userOnline": "{name} is online now.",
    "chat.newMessageFrom": "New message from {name}: {message}",
    "chat.newMessages": "{count} new chat messages.",
    "chat.localOnly":
      "Local chat mode. Apply the chat tables in backend to talk across devices.",
    "chat.empty": "No messages yet.",
    "chat.emptyDirect": "No messages with this person yet.",
    "chat.selectPerson": "Choose a person",
    "chat.selectPersonDescription": "Select someone online or offline to start a direct conversation.",
    "chat.selectFirst": "Choose a person first",
    "chat.placeholder": "Write a message...",
    "chat.send": "Send",
    "chat.sendError": "Could not send the message.",
    "map.welcome": "Welcome, {name}!",
    "map.explorer": "Explorer",
    "map.crew": "Crew",
    "map.globalAdmin": "Global Admin Console",
    "map.crewAdmin": "Crew Admin Console",
    "map.selfAssessment": "Self Assessment",
    "map.itemShop": "Island Item Shop",
    "map.pendingCrewInviteTitle": "Crew invitation waiting",
    "map.pendingCrewInviteDescription":
      "You have {count} crew invitation waiting. You have 24 hours from when it was sent to accept.",
    "map.newCrewInviteToast":
      "New crew invitation! You have 24 hours from when it was sent to accept.",
    "map.reviewCrewInvite": "Review invite",
    "map.yourJourney": "Your Journey",
    "map.progress": "Progress",
    "map.currentLevel": "Current level",
    "map.currentLevelDescription": "Level {level} of {count}",
    "map.streak": "Streak",
    "map.streakBonusTotal": "Offensive bonus saved: +{points} pts",
    "map.streakBonusNext":
      "Keep the streak alive on the next weekday to unlock +{points} more.",
    "streakCelebration.overline": "Welcome back",
    "streakCelebration.title": "Streak alive!",
    "streakCelebration.day": "day",
    "streakCelebration.days": "days",
    "streakCelebration.message": "Your daily streak is still burning.",
    "map.islandItems": "Island items",
    "map.nextUpgrade": "Next: {label} after {count} completed levels.",
    "map.legend": "Legend",
    "map.yourShip": "Your Ship",
    "map.yourBoat": "Your Boat",
    "map.yourLorry": "Your Lorry",
    "map.shopTitle": "Island shop",
    "map.shopDescription":
      "Unlock with levels and points. Choose Add, then click where it should go.",
    "map.dragShopPanel": "Drag shop panel",
    "map.localSaveNotice":
      "Saving on this device until the island table is applied in backend.",
    "map.placedItems": "Placed items",
    "map.noPlacedItems": "No items placed yet.",
    "map.unlockRequirement": "Level {level} • {points} pts",
    "map.unlockToast": "Unlocks at level {level} with {points} points.",
    "map.selected": "Selected",
    "map.add": "Add",
    "map.addItem": "Add item",
    "map.placeItem": "Choose a spot",
    "map.dragIsland": "Drag to reposition on the trail.",
    "map.resetIslandLayout": "Reset island layout",
    "map.resetIslandLayoutSuccess": "Island layout reset",
    "map.clickMoveItem":
      "Where do you want to move it? Click a land spot on the island.",
    "map.placeInstruction":
      "Where do you want to place {label}? Click a land spot.",
    "map.moveInstruction":
      "Where do you want to move {label}? Click a land spot.",
    "map.itemFallback": "item",
    "map.mapTitle": "The AI Island Map",
    "map.mapSubtitle": "Follow the trail through {count} levels",
    "map.loadError": "Could not load islands.",
    "map.signInCustomize": "Sign in to customize your island.",
    "map.addSuccess": "{label} added to the island",
    "map.addLocalInfo":
      "backend does not have the island table yet. I saved it on this device for now.",
    "map.addError": "Could not add the item to the island.",
    "map.moveSuccess": "Item repositioned",
    "map.moveLocalInfo":
      "Repositioned on this device. The backend migration still needs to be applied.",
    "map.moveError": "Could not move the item.",
    "map.removeSuccess": "Item removed from the island",
    "map.removeLocalInfo":
      "Removed on this device. The backend migration still needs to be applied.",
    "map.removeError": "Could not remove the item.",
    "map.moveItem": "Move item",
    "map.deleteItem": "Delete item",
    "map.chooseLand": "Choose a spot on the island land.",
    "map.completePrevious": "Complete the previous island first!",
    "map.crewAdvanceBlocked":
      "Your crew advances together. Everyone must complete the previous island first.",
    "shopItem.campfire-circle.label": "Living campfire",
    "shopItem.campfire-circle.description":
      "An animated campsite point for the trail.",
    "shopItem.trail-sign.label": "Trail sign",
    "shopItem.trail-sign.description":
      "Marks paths and achievements on the island.",
    "shopItem.flower-bed.label": "Flower garden",
    "shopItem.flower-bed.description":
      "A colorful small garden for beach edges.",
    "shopItem.river-dock.label": "River dock",
    "shopItem.river-dock.description": "A small wooden pier beside water.",
    "shopItem.stone-well.label": "Stone well",
    "shopItem.stone-well.description": "A rustic well for the inner path.",
    "shopItem.tulip-garden.label": "Dutch tulips",
    "shopItem.tulip-garden.description":
      "A compact tulip bed inspired by the Netherlands.",
    "shopItem.windmill-hut.label": "Windmill",
    "shopItem.windmill-hut.description":
      "A small windmill with spinning blades.",
    "shopItem.swedish-bridge.label": "Swedish bridge",
    "shopItem.swedish-bridge.description":
      "A tiny painted bridge for rivers and paths.",
    "shopItem.colorful-buildings.label": "Colorful buildings",
    "shopItem.colorful-buildings.description":
      "Small Swedish-style colorful buildings.",
    "shopItem.lighthouse.label": "Lighthouse",
    "shopItem.lighthouse.description": "A coastal light unlocked near the end.",
    "shopItem.orchard-grove.label": "Orchard",
    "shopItem.orchard-grove.description":
      "Fruit trees that make the island feel more alive.",
    "shopItem.pier-lantern.label": "Pier lantern",
    "shopItem.pier-lantern.description":
      "A small light for areas near the water.",
    "shopItem.victory-banner.label": "Banner",
    "shopItem.victory-banner.description":
      "A banner to mark crew achievements.",
    "shopItem.island-fountain.label": "Fountain",
    "shopItem.island-fountain.description":
      "A decorative fountain for the island square.",
    "shopItem.training-workshop.label": "Workshop",
    "shopItem.training-workshop.description":
      "A small workshop for projects and upgrades.",
    "shopItem.stone-gate.label": "Stone gate",
    "shopItem.stone-gate.description":
      "A gate that highlights the trail entrance.",
    "shopItem.treasure-chest.label": "Treasure chest",
    "shopItem.treasure-chest.description":
      "A chest for adventure rewards.",
    "shopItem.learning-library.label": "Library",
    "shopItem.learning-library.description":
      "A small library for crew knowledge.",
    "shopItem.skill-tower.label": "Tower",
    "shopItem.skill-tower.description":
      "A tall tower to track island progress.",
    "shopItem.glass-greenhouse.label": "Greenhouse",
    "shopItem.glass-greenhouse.description":
      "A glass greenhouse for a special green area.",
    "shopItem.observatory-dome.label": "Observatory",
    "shopItem.observatory-dome.description":
      "An observatory to spot new islands on the horizon.",
    "shopItem.crew-statue.label": "Statue",
    "shopItem.crew-statue.description": "A statue to celebrate explorers.",
    "stage.1": "Foundations",
    "stage.2": "Application",
    "stage.3": "Mastery",
    "island.notFound": "Island not found",
    "island.stage": "Stage",
    "island.questionShort": "Q",
    "island.questionsToPass": "{count} questions • {points} pts • 70% to pass",
    "island.questionsToAdvance":
      "{count} questions • {points} pts • Score 70% or higher to advance",
    "island.speedBonusHint": "Answer faster for up to +3 bonus points.",
    "island.speedBonusEarned": "+{points} speed bonus in {seconds}s",
    "island.beginJourney": "Begin Journey",
    "island.noQuestions": "No questions available for this island yet.",
    "island.startStage": "Start Stage {stage}",
    "island.submitAnswer": "Submit Answer",
    "island.checking": "Checking...",
    "island.correct": "Correct!",
    "island.notQuite": "Not quite right",
    "island.whyRight": "Why this is right",
    "island.whyWrong": "Why this was not the best answer",
    "island.yourAnswer": "Your answer",
    "island.correctAnswer": "Correct answer",
    "island.defaultRight":
      "This answer matches the safest and most practical choice for the scenario.",
    "island.defaultWrong":
      "Review the correct answer and compare it with the option you selected.",
    "island.nextQuestion": "Next Question",
    "island.completeStage": "Complete Stage",
    "island.stageComplete": "Stage {stage} Complete!",
    "island.stageNotPassed": "Stage {stage} Not Passed",
    "island.nextChallenge": "Great work! Ready for the next challenge?",
    "island.islandConqueredStage": "Amazing! You've conquered this island!",
    "island.needToAdvance": "You need 70% to advance. Review and try again!",
    "island.stageScoreLine":
      "{score}/{possible} pts • {correct} of {total} correct",
    "island.progressTitle": "Island Progress",
    "island.stationCompleteShort": "Complete",
    "island.stationAlreadyComplete":
      "This stage is already complete. Choose another one.",
    "island.nextStationStage": "Stage {stage} next",
    "island.backToStations": "Back to stages",
    "island.chooseAnotherStation": "Choose another stage",
    "island.completeAllStations":
      "Complete every stage on this island before moving on.",
    "island.startNextStage": "Start Stage {stage}",
    "island.completeIsland": "Complete Island",
    "island.retryStage": "Retry Stage",
    "island.conquered": "Island Conquered!",
    "island.conqueredSubtitle": "You've mastered all 3 stages of {name}!",
    "island.correctOverall":
      "{percent}% • {correct} of {total} correct overall",
    "island.playAgain": "Play Again",
    "island.loadError": "Failed to load island data",
    "island.startError": "Failed to start stage",
    "island.submitError": "Failed to submit answer",
    "settings.title": "Settings",
    "settings.profileTitle": "Profile Settings",
    "settings.profileDescription": "Customize your explorer profile",
    "settings.avatarUrl": "Avatar URL",
    "settings.uploadAvatar": "Upload image",
    "settings.uploadingAvatar": "Uploading...",
    "settings.avatarUploadHint": "Choose a JPG, PNG or WebP from this device.",
    "settings.avatarUploadError":
      "Failed to upload image. Check the storage configuration.",
    "settings.avatarImageOnly": "Please choose an image file.",
    "settings.avatarUploadSuccess": "Avatar image uploaded.",
    "settings.explorerName": "Explorer Name",
    "settings.accountEmail": "Account email",
    "settings.accountEmailDescription":
      "Use this email to sign in and receive crew invitations.",
    "settings.updateEmail": "Update email",
    "settings.emailInvalid": "Enter a valid email.",
    "settings.emailUnchanged": "This is already your current email.",
    "settings.emailUpdateSuccess": "Email updated.",
    "settings.emailUpdateError": "Failed to update email.",
    "settings.emailAlreadyRegistered": "This email is already registered.",
    "settings.profileStatusMessage": "Message below your name",
    "settings.profileStatusMessagePlaceholder": "Write a welcome message...",
    "settings.hub": "Hub",
    "settings.saveChanges": "Save Changes",
    "settings.updateError": "Failed to update profile",
    "settings.updateSuccess": "Profile updated!",
    "settings.languageTitle": "Game language",
    "settings.languageDescription":
      "Choose the language used by the game interface.",
    "settings.dangerTitle": "Danger zone",
    "settings.deleteAccount": "Delete my profile",
    "settings.deleteAccountDescription":
      "This permanently deletes your account, profile, progress, crew membership and sessions. You can register again with the same email afterward.",
    "settings.deleteAccountConfirm":
      'Type "{phrase}" to permanently delete your profile.',
    "settings.deleteAccountConfirmError": "Profile deletion was not confirmed.",
    "settings.deleteAccountSuccess": "Profile deleted. You can register again.",
    "settings.deleteAccountError": "Failed to delete profile.",
    "auth.subtitle":
      "Logistics Intelligence Navigator Adventure for AI adoption",
    "auth.title": "Set Sail!",
    "auth.loginDescription": "Welcome back, explorer! Continue your adventure.",
    "auth.signupDescription":
      "Join the crew and start your AI learning journey.",
    "auth.login": "Login",
    "auth.signUp": "Sign Up",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirmPassword": "Confirm Password",
    "auth.explorerName": "Explorer Name",
    "auth.hub": "Hub",
    "auth.chooseHub": "Choose your hub",
    "auth.hubRequired": "Choose your hub to continue.",
    "auth.loggingIn": "Setting sail...",
    "auth.signingUp": "Preparing your ship...",
    "auth.joinAdventure": "Join the Adventure",
    "auth.footer": "Learn AI concepts through an exciting tropical adventure!",
    "auth.invalidCredentials": "Invalid email or password. Please try again.",
    "auth.passwordsDoNotMatch": "Passwords do not match",
    "auth.emailRegistered":
      "This email is already registered. Try logging in instead!",
    "auth.welcomeBack": "Welcome back, explorer!",
    "auth.welcomeAboard": "Welcome aboard, new explorer!",
    "assessment.title": "Self Assessment",
    "assessment.description":
      "Test your AI knowledge with true or false questions. This will help you understand your current knowledge level!",
    "assessment.previousAttempts": "Previous Attempts",
    "assessment.completedOnce": "Assessment completed",
    "assessment.noRetake": "This assessment can only be completed once.",
    "assessment.start": "Start Assessment",
    "assessment.retake": "Retake Assessment",
    "assessment.retakeShort": "Retake",
    "assessment.questionOf": "Question {current} of {total}",
    "assessment.true": "True",
    "assessment.false": "False",
    "assessment.incorrectAnswer": "Incorrect - the answer is {answer}",
    "assessment.seeResults": "See Results",
    "assessment.excellent": "Excellent!",
    "assessment.goodJob": "Good Job!",
    "assessment.niceTry": "Nice Try!",
    "assessment.keepLearning": "Keep Learning!",
    "assessment.strongFoundation":
      "You have a strong foundation in AI knowledge!",
    "assessment.rightTrack":
      "You're on the right track! Keep exploring the islands to learn more.",
    "assessment.buildKnowledge":
      "The island adventures will help you build your AI knowledge!",
    "assessment.exploreIslands": "Explore Islands",
    "assessment.loadError": "Failed to load assessment",
    "assessment.saveError": "Failed to save your results",
    "assessment.finalTitle": "Final reassessment",
    "assessment.finalDescription":
      "All islands are complete. Retake this assessment and score at least {rate}% to qualify for victory.",
    "assessment.finalComplete": "Your final reassessment is complete.",
    "assessment.startFinal": "Start final reassessment",
    "assessment.finalPassedResult":
      "This score satisfies the victory requirement.",
    "assessment.finalRetryResult":
      "The victory requirement is {rate}% or higher. You can retake while you are at the final gate.",
    "assessment.viewVictory": "View victory",
    "winner.title": "Victory",
    "winner.subtitle": "Final gate and winner declaration",
    "winner.refresh": "Refresh",
    "winner.loadErrorTitle": "Could not load victory data",
    "winner.declared": "Winner declared",
    "winner.soloDeclared": "Player winner declared",
    "winner.declaredOn": "Declared on",
    "winner.qualifiedMembers": "Qualified members",
    "winner.islandsEach": "Islands each",
    "winner.crewPoints": "Crew points",
    "winner.playerPoints": "Player points",
    "winner.tabs.overview": "Overview",
    "winner.tabs.player": "Player winner",
    "winner.tabs.crew": "Winning crew",
    "winner.finalResults": "Final reassessment results",
    "winner.noWinnerBadge": "No winner declared yet",
    "winner.waitingTitle": "The final gate is still open.",
    "winner.waitingDescription":
      "A crew or solo player is declared winner only after every required island is complete, the final reassessment is passed with {rate}% or higher, and each qualified player declares victory.",
    "winner.requirementsTitle": "Victory requirements",
    "winner.requirement.validEntry": "Valid crew or solo player",
    "winner.requirement.islands": "Complete every required island",
    "winner.requirement.final": "Pass the final reassessment",
    "winner.requirement.declare": "Each qualified player declares victory",
    "winner.yourEntry": "Your run: {name}",
    "winner.yourCrew": "Your crew: {name}",
    "winner.finalReassessment": "Final reassessment",
    "winner.finalReassessmentLocked": "Final reassessment locked",
    "winner.finalLockedDescription":
      "It unlocks after the last required island is complete.",
    "winner.progressTitle": "Progress",
    "winner.progressLiveDescription":
      "Live ranking by points. Declared winners stay in history while other crews can still pass first place.",
    "winner.progressDescription":
      "Live ranking by points. Declared winners stay in history while other crews can still pass first place.",
    "winner.noCrews": "No crews or solo runs have progress yet.",
    "winner.members": "{count} members",
    "winner.solo": "Solo",
    "winner.points": "{points} points",
    "winner.islands": "Islands",
    "winner.finalCheck": "Final check",
    "winner.memberIslands": "Islands",
    "winner.memberFinal": "Final",
    "winner.memberDeclaration": "Declaration",
    "winner.memberStreakBonus": "Offensive bonus",
    "winner.pending": "pending",
    "winner.declaredStatus": "declared",
    "winner.notDeclaredStatus": "not declared",
    "winner.declarationOpen":
      "Final checks are complete. Each qualified player must declare victory.",
    "winner.declareVictory": "Declare victory",
    "winner.declareLocked": "Final gate charging",
    "winner.declaringVictory": "Declaring...",
    "winner.declareSuccess": "Victory declaration recorded.",
    "winner.declareLocalSuccess":
      "Declaration saved on this device. Apply the backend table so teammates can see it.",
    "winner.declareAlreadyDone": "Victory declared",
    "winner.declareReadyHint":
      "Everything is ready. Press the crown and make this victory official.",
    "winner.declareLockedHint":
      "Finish the last requirements to wake up the victory button.",
    "winner.declareLockedIslandsHint":
      "Complete every required island to charge this button.",
    "winner.declareLockedAssessmentHint":
      "Retake the self assessment and score 90% or higher to unlock victory.",
    "winner.declareLockedTeamHint":
      "Waiting for every qualified player to pass the final reassessment.",
    "winner.declareWaitingTeamHint":
      "Your declaration is in. When everyone declares, this crew becomes a winner.",
    "winner.declareWinnerHint":
      "Victory is official, but the leaderboard keeps moving.",
    "winner.declareDissolvedHint":
      "This winning crew has finished this version and is waiting for the next phase.",
    "winner.dissolvesOn": "Crew releases on",
    "winner.dissolvedTitle": "New islands are still being discovered.",
    "winner.dissolvedDescription":
      "This winning crew completed this version of the game. Wait for the next version with a new phase and new islands soon.",
    "winner.dissolutionNote":
      "Winning crews are released {days} days after victory so the rest of the game can continue.",
    "winner.playerWinnerTitle": "Player winner",
    "winner.playerWinnerDescriptionSolo":
      "This player completed every island and passed the final reassessment.",
    "winner.playerWinnerDescriptionCrew":
      "Highest scorer inside the winning crew.",
    "winner.noPlayerWinner": "No player winner has been declared yet.",
    "winner.crewRankingTitle": "Winning crew scoring",
    "winner.noCrewWinner": "No winning crew has been declared yet.",
    "winner.soloWinnerNoCrew":
      "This victory is solo, so there is no crew ranking.",
    "winner.winnerBadge": "Winner",
    "winner.topScorerBadge": "Top scorer",
    "winner.currentUserStatusWinner": "This run has been declared winner.",
    "winner.currentUserStatusProgress":
      "{percent}% of island progress completed.",
    "winner.currentUserStatusNeedsAssessment":
      "You reached the final gate. Complete the reassessment to qualify.",
    "winner.currentUserStatusCanDeclare":
      "Your final check is approved. Declare victory to finish your part.",
    "winner.currentUserStatusDeclared":
      "You declared victory. Waiting for the remaining qualified players.",
    "winner.currentUserStatusWaiting":
      "Waiting for every required final reassessment to pass.",
  },
  pt: {
    "language.label": "Idioma",
    "language.en": "Inglês",
    "language.pt": "Português",
    "language.nl": "Holandês",
    "language.sv": "Sueco",
    "common.points": "Pontos",
    "common.pointsShort": "pts",
    "common.completed": "Concluído",
    "common.current": "Atual",
    "common.locked": "Bloqueado",
    "common.cancel": "Cancelar",
    "common.backToMap": "Voltar ao mapa",
    "common.returnToMap": "Voltar ao mapa",
    "common.settings": "Configurações",
    "common.signOut": "Sair",
    "common.zoomIn": "Aproximar",
    "common.zoomOut": "Afastar",
    "common.resetView": "Redefinir visão",
    "common.level": "Nível",
    "brand.fullName": "LOGISTIC INTELLIGENCE NAVIGATOR FOR AI ADOPTION",
    "chat.open": "Abrir chat",
    "chat.dragPanel": "Arrastar chat",
    "chat.minimize": "Minimizar chat",
    "chat.close": "Fechar chat",
    "chat.statusOnline": "Online",
    "chat.statusOffline": "Offline",
    "chat.goOnline": "Ficar online",
    "chat.goOffline": "Ficar offline",
    "chat.title": "Mensagens diretas",
    "chat.online": "Online",
    "chat.onlineCount": "Online: {count}",
    "chat.offline": "Offline",
    "chat.statusCount": "{online} online / {offline} offline",
    "chat.userOnline": "{name} ficou online.",
    "chat.newMessageFrom": "Nova mensagem de {name}: {message}",
    "chat.newMessages": "{count} novas mensagens no chat.",
    "chat.localOnly":
      "Modo de chat local. Aplique as tabelas de chat no backend para conversar entre dispositivos.",
    "chat.empty": "Nenhuma mensagem ainda.",
    "chat.emptyDirect": "Nenhuma mensagem com esta pessoa ainda.",
    "chat.selectPerson": "Escolha uma pessoa",
    "chat.selectPersonDescription": "Selecione alguem online ou offline para iniciar uma conversa individual.",
    "chat.selectFirst": "Escolha uma pessoa primeiro",
    "chat.placeholder": "Escreva uma mensagem...",
    "chat.send": "Enviar",
    "chat.sendError": "Nao foi possivel enviar a mensagem.",
    "map.welcome": "Bem-vindo, {name}!",
    "map.explorer": "Explorador",
    "map.crew": "Crew",
    "map.globalAdmin": "Admin global",
    "map.crewAdmin": "Admin da equipe",
    "map.selfAssessment": "Autoavaliação",
    "map.itemShop": "Loja de itens da ilha",
    "map.pendingCrewInviteTitle": "Convite de crew pendente",
    "map.pendingCrewInviteDescription":
      "Voce tem {count} convite de crew aguardando. Voce tem 24 horas a partir do envio para aceitar.",
    "map.newCrewInviteToast":
      "Novo convite de crew! Voce tem 24 horas a partir do envio para aceitar.",
    "map.reviewCrewInvite": "Ver convite",
    "map.yourJourney": "Sua jornada",
    "map.progress": "Progresso",
    "map.currentLevel": "Nível atual",
    "map.currentLevelDescription": "Nível {level} de {count}",
    "map.streak": "Ofensiva",
    "map.streakBonusTotal": "Bonus de ofensiva salvo: +{points} pts",
    "map.streakBonusNext":
      "Mantenha a ofensiva no proximo dia util para liberar +{points} a mais.",
    "streakCelebration.overline": "Bem-vindo de volta",
    "streakCelebration.title": "Ofensiva ativa!",
    "streakCelebration.day": "dia",
    "streakCelebration.days": "dias",
    "streakCelebration.message": "Sua sequencia diaria continua acesa.",
    "map.islandItems": "Itens da ilha",
    "map.nextUpgrade": "Próximo: {label} após {count} níveis concluídos.",
    "map.legend": "Legenda",
    "map.yourShip": "Seu navio",
    "map.yourBoat": "Seu barco",
    "map.yourLorry": "Seu caminhão",
    "map.shopTitle": "Loja da ilha",
    "map.shopDescription":
      "Desbloqueie por níveis e pontos. Clique em Adicionar e escolha onde colocar na ilha.",
    "map.dragShopPanel": "Arrastar lojinha",
    "map.localSaveNotice":
      "Salvando neste dispositivo até a tabela da ilha ser aplicada no backend.",
    "map.placedItems": "Itens colocados",
    "map.noPlacedItems": "Nenhum item colocado ainda.",
    "map.unlockRequirement": "Nível {level} • {points} pts",
    "map.unlockToast": "Libera no nível {level} com {points} pontos.",
    "map.selected": "Selecionado",
    "map.add": "Adicionar",
    "map.addItem": "Adicionar item",
    "map.placeItem": "Escolher ponto",
    "map.dragIsland": "Arraste para reposicionar na trilha.",
    "map.resetIslandLayout": "Redefinir posicao das ilhas",
    "map.resetIslandLayoutSuccess": "Posicao das ilhas redefinida",
    "map.clickMoveItem":
      "Onde você quer mover? Clique em um ponto de terra da ilha.",
    "map.placeInstruction":
      "Onde você quer colocar {label}? Clique em um ponto de terra.",
    "map.moveInstruction":
      "Onde você quer mover {label}? Clique em um ponto de terra.",
    "map.itemFallback": "item",
    "map.mapTitle": "O mapa da ilha de IA",
    "map.mapSubtitle": "Siga a trilha por {count} níveis",
    "map.loadError": "Não consegui carregar as ilhas.",
    "map.signInCustomize": "Entre na conta para personalizar sua ilha.",
    "map.addSuccess": "{label} adicionado à ilha",
    "map.addLocalInfo":
      "O backend ainda não tem a tabela da ilha. Salvei neste dispositivo por enquanto.",
    "map.addError": "Não consegui adicionar o item na ilha.",
    "map.moveSuccess": "Item reposicionado",
    "map.moveLocalInfo":
      "Reposicionei neste dispositivo. A migration do backend ainda precisa ser aplicada.",
    "map.moveError": "Não consegui mover o item.",
    "map.removeSuccess": "Item removido da ilha",
    "map.removeLocalInfo":
      "Removi neste dispositivo. A migration do backend ainda precisa ser aplicada.",
    "map.removeError": "Não consegui remover o item.",
    "map.moveItem": "Mover item",
    "map.deleteItem": "Excluir item",
    "map.chooseLand": "Escolha um ponto dentro da terra da ilha.",
    "map.completePrevious": "Complete a ilha anterior primeiro!",
    "map.crewAdvanceBlocked":
      "A crew avança junta. Todos precisam concluir a ilha anterior primeiro.",
    "shopItem.campfire-circle.label": "Fogueira viva",
    "shopItem.campfire-circle.description":
      "Um ponto de acampamento animado para a trilha.",
    "shopItem.trail-sign.label": "Placa da trilha",
    "shopItem.trail-sign.description": "Marca caminhos e conquistas na ilha.",
    "shopItem.flower-bed.label": "Jardim de flores",
    "shopItem.flower-bed.description":
      "Um pequeno jardim colorido para as bordas da praia.",
    "shopItem.river-dock.label": "Pier de rio",
    "shopItem.river-dock.description":
      "Um pequeno pier de madeira ao lado da água.",
    "shopItem.stone-well.label": "Poço de pedra",
    "shopItem.stone-well.description": "Um poço rústico para a trilha interna.",
    "shopItem.tulip-garden.label": "Tulipas da Holanda",
    "shopItem.tulip-garden.description":
      "Um canteiro compacto de tulipas inspirado na Holanda.",
    "shopItem.windmill-hut.label": "Moinho",
    "shopItem.windmill-hut.description":
      "Um pequeno moinho com hélices girando.",
    "shopItem.swedish-bridge.label": "Ponte sueca",
    "shopItem.swedish-bridge.description":
      "Uma pequena ponte pintada para rios e caminhos.",
    "shopItem.colorful-buildings.label": "Prédios coloridos",
    "shopItem.colorful-buildings.description":
      "Pequenos prédios coloridos no estilo sueco.",
    "shopItem.lighthouse.label": "Farol",
    "shopItem.lighthouse.description":
      "Uma luz costeira desbloqueada perto do final.",
    "shopItem.orchard-grove.label": "Pomar",
    "shopItem.orchard-grove.description":
      "Arvores frutiferas para deixar a ilha mais viva.",
    "shopItem.pier-lantern.label": "Lanterna do pier",
    "shopItem.pier-lantern.description":
      "Um ponto de luz para areas proximas da agua.",
    "shopItem.victory-banner.label": "Bandeira",
    "shopItem.victory-banner.description":
      "Uma bandeira para marcar conquistas da tripulacao.",
    "shopItem.island-fountain.label": "Fonte",
    "shopItem.island-fountain.description":
      "Uma fonte decorativa para a praca da ilha.",
    "shopItem.training-workshop.label": "Oficina",
    "shopItem.training-workshop.description":
      "Uma pequena oficina para projetos e melhorias.",
    "shopItem.stone-gate.label": "Portal de pedra",
    "shopItem.stone-gate.description":
      "Um portal para destacar a entrada da trilha.",
    "shopItem.treasure-chest.label": "Bau do tesouro",
    "shopItem.treasure-chest.description":
      "Um bau para guardar recompensas da aventura.",
    "shopItem.learning-library.label": "Biblioteca",
    "shopItem.learning-library.description":
      "Uma biblioteca pequena para conhecimento da crew.",
    "shopItem.skill-tower.label": "Torre",
    "shopItem.skill-tower.description":
      "Uma torre alta para acompanhar o progresso da ilha.",
    "shopItem.glass-greenhouse.label": "Estufa",
    "shopItem.glass-greenhouse.description":
      "Uma estufa de vidro para uma area verde especial.",
    "shopItem.observatory-dome.label": "Observatorio",
    "shopItem.observatory-dome.description":
      "Um observatorio para olhar novas ilhas no horizonte.",
    "shopItem.crew-statue.label": "Estatua",
    "shopItem.crew-statue.description":
      "Uma estatua para celebrar os exploradores.",
    "stage.1": "Fundamentos",
    "stage.2": "Aplicação",
    "stage.3": "Domínio",
    "island.notFound": "Ilha não encontrada",
    "island.stage": "Etapa",
    "island.questionShort": "P",
    "island.questionsToPass":
      "{count} questões • {points} pts • 70% para passar",
    "island.questionsToAdvance":
      "{count} questões • {points} pts • Faça 70% ou mais para avançar",
    "island.speedBonusHint":
      "Responda mais rápido para ganhar até +3 pontos extras.",
    "island.speedBonusEarned": "+{points} de bônus rápido em {seconds}s",
    "island.beginJourney": "Começar jornada",
    "island.noQuestions": "Ainda não há questões para esta ilha.",
    "island.startStage": "Começar etapa {stage}",
    "island.submitAnswer": "Enviar resposta",
    "island.checking": "Conferindo...",
    "island.correct": "Correto!",
    "island.notQuite": "Ainda não foi dessa vez",
    "island.whyRight": "Por que está certo",
    "island.whyWrong": "Por que não era a melhor resposta",
    "island.yourAnswer": "Sua resposta",
    "island.correctAnswer": "Resposta correta",
    "island.defaultRight":
      "Esta resposta combina com a escolha mais segura e prática para o cenário.",
    "island.defaultWrong":
      "Revise a resposta correta e compare com a opção que você escolheu.",
    "island.nextQuestion": "Próxima questão",
    "island.completeStage": "Concluir etapa",
    "island.stageComplete": "Etapa {stage} concluída!",
    "island.stageNotPassed": "Etapa {stage} não aprovada",
    "island.nextChallenge": "Muito bom! Pronto para o próximo desafio?",
    "island.islandConqueredStage": "Incrível! Você conquistou esta ilha!",
    "island.needToAdvance":
      "Você precisa de 70% para avançar. Revise e tente de novo!",
    "island.stageScoreLine":
      "{score}/{possible} pts • {correct} de {total} corretas",
    "island.progressTitle": "Progresso da ilha",
    "island.stationCompleteShort": "Concluído",
    "island.stationAlreadyComplete":
      "Este stage já foi concluído. Escolha outro.",
    "island.nextStationStage": "Stage {stage} agora",
    "island.backToStations": "Voltar aos stages",
    "island.chooseAnotherStation": "Escolher outro stage",
    "island.completeAllStations":
      "Conclua todos os stages desta ilha antes de seguir.",
    "island.startNextStage": "Começar etapa {stage}",
    "island.completeIsland": "Concluir ilha",
    "island.retryStage": "Tentar etapa de novo",
    "island.conquered": "Ilha conquistada!",
    "island.conqueredSubtitle": "Você dominou todas as 3 etapas de {name}!",
    "island.correctOverall":
      "{percent}% • {correct} de {total} corretas no total",
    "island.playAgain": "Jogar de novo",
    "island.loadError": "Falha ao carregar os dados da ilha",
    "island.startError": "Falha ao iniciar a etapa",
    "island.submitError": "Falha ao enviar resposta",
    "settings.title": "Configurações",
    "settings.profileTitle": "Configurações do perfil",
    "settings.profileDescription": "Personalize seu perfil de explorador",
    "settings.avatarUrl": "URL do avatar",
    "settings.uploadAvatar": "Enviar imagem",
    "settings.uploadingAvatar": "Enviando...",
    "settings.avatarUploadHint":
      "Escolha um JPG, PNG ou WebP deste dispositivo.",
    "settings.avatarUploadError":
      "Falha ao enviar a imagem. Verifique a configuração do storage.",
    "settings.avatarImageOnly": "Escolha um arquivo de imagem.",
    "settings.avatarUploadSuccess": "Imagem do avatar enviada.",
    "settings.explorerName": "Nome do explorador",
    "settings.accountEmail": "Email da conta",
    "settings.accountEmailDescription":
      "Use este email para entrar e receber convites de crew.",
    "settings.updateEmail": "Atualizar email",
    "settings.emailInvalid": "Informe um email valido.",
    "settings.emailUnchanged": "Este ja e seu email atual.",
    "settings.emailUpdateSuccess": "Email atualizado.",
    "settings.emailUpdateError": "Falha ao atualizar email.",
    "settings.emailAlreadyRegistered": "Este email ja esta cadastrado.",
    "settings.profileStatusMessage": "Mensagem abaixo do seu nome",
    "settings.profileStatusMessagePlaceholder":
      "Escreva uma mensagem de boas-vindas...",
    "settings.hub": "Hub",
    "settings.saveChanges": "Salvar alterações",
    "settings.updateError": "Falha ao atualizar perfil",
    "settings.updateSuccess": "Perfil atualizado!",
    "settings.languageTitle": "Idioma do jogo",
    "settings.languageDescription":
      "Escolha o idioma usado pela interface do jogo.",
    "settings.dangerTitle": "Zona de perigo",
    "settings.deleteAccount": "Excluir meu perfil",
    "settings.deleteAccountDescription":
      "Isso apaga permanentemente sua conta, perfil, progresso, crew, sessoes e permite cadastrar de novo com o mesmo email depois.",
    "settings.deleteAccountConfirm":
      'Digite "{phrase}" para excluir permanentemente seu perfil.',
    "settings.deleteAccountConfirmError":
      "A exclusao do perfil nao foi confirmada.",
    "settings.deleteAccountSuccess":
      "Perfil excluido. Voce pode se cadastrar de novo.",
    "settings.deleteAccountError": "Falha ao excluir perfil.",
    "auth.subtitle":
      "Aventura de adoção de IA com o navegador inteligente de logística",
    "auth.title": "Começar viagem!",
    "auth.loginDescription":
      "Bem-vindo de volta, explorador! Continue sua aventura.",
    "auth.signupDescription":
      "Entre na equipe e comece sua jornada de aprendizado em IA.",
    "auth.login": "Entrar",
    "auth.signUp": "Criar conta",
    "auth.email": "Email",
    "auth.password": "Senha",
    "auth.confirmPassword": "Confirmar senha",
    "auth.explorerName": "Nome do explorador",
    "auth.hub": "Hub",
    "auth.chooseHub": "Escolha seu hub",
    "auth.hubRequired": "Escolha seu hub para continuar.",
    "auth.loggingIn": "Entrando...",
    "auth.signingUp": "Preparando sua conta...",
    "auth.joinAdventure": "Entrar na aventura",
    "auth.footer": "Aprenda conceitos de IA em uma aventura tropical!",
    "auth.invalidCredentials": "Email ou senha inválidos. Tente novamente.",
    "auth.passwordsDoNotMatch": "As senhas não coincidem",
    "auth.emailRegistered": "Este email já está cadastrado. Tente entrar.",
    "auth.welcomeBack": "Bem-vindo de volta, explorador!",
    "auth.welcomeAboard": "Bem-vindo a bordo, novo explorador!",
    "assessment.title": "Autoavaliação",
    "assessment.description":
      "Teste seu conhecimento de IA com perguntas de verdadeiro ou falso. Isso ajuda a entender seu nível atual.",
    "assessment.previousAttempts": "Tentativas anteriores",
    "assessment.completedOnce": "Autoavaliação concluída",
    "assessment.noRetake": "Esta autoavaliação só pode ser feita uma vez.",
    "assessment.start": "Começar avaliação",
    "assessment.retake": "Refazer avaliação",
    "assessment.retakeShort": "Refazer",
    "assessment.questionOf": "Questão {current} de {total}",
    "assessment.true": "Verdadeiro",
    "assessment.false": "Falso",
    "assessment.incorrectAnswer": "Incorreto - a resposta é {answer}",
    "assessment.seeResults": "Ver resultados",
    "assessment.excellent": "Excelente!",
    "assessment.goodJob": "Muito bom!",
    "assessment.niceTry": "Boa tentativa!",
    "assessment.keepLearning": "Continue aprendendo!",
    "assessment.strongFoundation":
      "Você tem uma base forte em conhecimento de IA!",
    "assessment.rightTrack":
      "Você está no caminho certo! Continue explorando as ilhas para aprender mais.",
    "assessment.buildKnowledge":
      "As aventuras nas ilhas vão ajudar você a construir seu conhecimento de IA!",
    "assessment.exploreIslands": "Explorar ilhas",
    "assessment.loadError": "Falha ao carregar a avaliação",
    "assessment.saveError": "Falha ao salvar seus resultados",
    "assessment.finalTitle": "Reavaliação final",
    "assessment.finalDescription":
      "Todas as ilhas foram concluídas. Refaca esta avaliação e tire pelo menos {rate}% para se qualificar para a vitória.",
    "assessment.finalComplete": "Sua reavaliação final está completa.",
    "assessment.startFinal": "Iniciar reavaliação final",
    "assessment.finalPassedResult":
      "Esta pontuação atende ao requisito de vitória.",
    "assessment.finalRetryResult":
      "O requisito de vitória é {rate}% ou mais. Você pode tentar novamente enquanto estiver no portão final.",
    "assessment.viewVictory": "Ver vitória",
    "winner.title": "Vitória",
    "winner.subtitle": "Portão final e declaração do vencedor",
    "winner.refresh": "Atualizar",
    "winner.loadErrorTitle": "Não foi possível carregar os dados da vitória",
    "winner.declared": "Vencedor declarado",
    "winner.soloDeclared": "Player vencedor declarado",
    "winner.declaredOn": "Declarado em",
    "winner.qualifiedMembers": "Membros qualificados",
    "winner.islandsEach": "Ilhas por pessoa",
    "winner.crewPoints": "Pontos da crew",
    "winner.playerPoints": "Pontos do player",
    "winner.tabs.overview": "Visão geral",
    "winner.tabs.player": "Player vencedor",
    "winner.tabs.crew": "Crew vencedora",
    "winner.finalResults": "Resultados da reavaliação final",
    "winner.noWinnerBadge": "Nenhum vencedor declarado ainda",
    "winner.waitingTitle": "O portão final ainda está aberto.",
    "winner.waitingDescription":
      "Uma crew ou player solo só é declarado vencedor depois de concluir todas as ilhas obrigatórias, passar na reavaliação final com {rate}% ou mais e cada player qualificado declarar vitória.",
    "winner.requirementsTitle": "Requisitos de vitória",
    "winner.requirement.validEntry": "Crew válida ou player solo",
    "winner.requirement.islands": "Concluir todas as ilhas obrigatórias",
    "winner.requirement.final": "Passar na reavaliação final",
    "winner.requirement.declare": "Cada player qualificado declara vitória",
    "winner.yourEntry": "Sua jornada: {name}",
    "winner.yourCrew": "Sua crew: {name}",
    "winner.finalReassessment": "Reavaliação final",
    "winner.finalReassessmentLocked": "Reavaliação final bloqueada",
    "winner.finalLockedDescription":
      "Só será liberada depois da conclusão da última ilha obrigatória.",
    "winner.progressTitle": "Progresso",
    "winner.progressLiveDescription":
      "Ranking ao vivo por pontos. Vencedores declarados ficam no historico enquanto outras crews ainda podem assumir o primeiro lugar.",
    "winner.progressDescription":
      "Crews e players solo mais próximos por conclusão de ilhas e reavaliação final.",
    "winner.noCrews": "Nenhuma crew ou jornada solo tem progresso ainda.",
    "winner.members": "{count} membros",
    "winner.solo": "Solo",
    "winner.points": "{points} pontos",
    "winner.islands": "Ilhas",
    "winner.finalCheck": "Checagem final",
    "winner.memberIslands": "Ilhas",
    "winner.memberFinal": "Final",
    "winner.memberDeclaration": "Declaração",
    "winner.memberStreakBonus": "Bonus de ofensiva",
    "winner.pending": "pendente",
    "winner.declaredStatus": "declarou",
    "winner.notDeclaredStatus": "não declarou",
    "winner.declarationOpen":
      "As checagens finais foram concluídas. Cada player qualificado precisa declarar vitória.",
    "winner.declareVictory": "Declarar vitória",
    "winner.declareLocked": "Portao final carregando",
    "winner.declaringVictory": "Declarando...",
    "winner.declareAlreadyDone": "Vitoria declarada",
    "winner.declareReadyHint":
      "Tudo pronto. Pressione a coroa e oficialize essa vitoria.",
    "winner.declareLockedHint":
      "Conclua os ultimos requisitos para acordar o botao de vitoria.",
    "winner.declareLockedIslandsHint":
      "Conclua todas as ilhas obrigatorias para carregar este botao.",
    "winner.declareLockedAssessmentHint":
      "Refaca o self assessment e tire 90% ou mais para liberar a vitoria.",
    "winner.declareLockedTeamHint":
      "Aguardando todos os players qualificados passarem na reavaliacao final.",
    "winner.declareWaitingTeamHint":
      "Sua declaracao entrou. Quando todos declararem, a crew vira vencedora.",
    "winner.declareWinnerHint":
      "A vitoria esta oficial, mas o ranking continua em movimento.",
    "winner.declareDissolvedHint":
      "Esta crew vencedora concluiu esta versao e aguarda a proxima fase.",
    "winner.declareSuccess": "Declaração de vitória registrada.",
    "winner.declareLocalSuccess":
      "Declaração salva neste dispositivo. Aplique a tabela no backend para o time inteiro enxergar.",
    "winner.dissolvesOn": "Crew será liberada em",
    "winner.dissolvedTitle": "Novas ilhas ainda estão sendo descobertas.",
    "winner.dissolvedDescription":
      "Esta crew vencedora concluiu esta versão do jogo. Aguarde a próxima versão com nova fase e novas ilhas em breve.",
    "winner.dissolutionNote":
      "Crews vencedoras são liberadas {days} dias após a vitória para o restante do jogo continuar.",
    "winner.playerWinnerTitle": "Player vencedor",
    "winner.playerWinnerDescriptionSolo":
      "Este player concluiu todas as ilhas e passou na reavaliação final.",
    "winner.playerWinnerDescriptionCrew":
      "Maior pontuador dentro da crew vencedora.",
    "winner.noPlayerWinner": "Nenhum player vencedor foi declarado ainda.",
    "winner.crewRankingTitle": "Pontuação da crew vencedora",
    "winner.noCrewWinner": "Nenhuma crew vencedora foi declarada ainda.",
    "winner.soloWinnerNoCrew":
      "Esta vitória é solo, então não há ranking de crew.",
    "winner.winnerBadge": "Vencedor",
    "winner.topScorerBadge": "Maior pontuador",
    "winner.currentUserStatusWinner": "Esta jornada foi declarada vencedora.",
    "winner.currentUserStatusProgress":
      "{percent}% do progresso de ilhas concluído.",
    "winner.currentUserStatusNeedsAssessment":
      "Você chegou ao portão final. Faça a reavaliação para se qualificar.",
    "winner.currentUserStatusCanDeclare":
      "Sua checagem final foi aprovada. Declare vitória para concluir sua parte.",
    "winner.currentUserStatusDeclared":
      "Você declarou vitória. Aguardando os outros players qualificados.",
    "winner.currentUserStatusWaiting":
      "Aguardando todas as reavaliações finais obrigatórias serem aprovadas.",
  },
  nl: {
    "language.label": "Taal",
    "language.en": "Engels",
    "language.pt": "Portugees",
    "language.nl": "Nederlands",
    "language.sv": "Zweeds",
    "common.points": "Punten",
    "common.pointsShort": "pt",
    "common.completed": "Voltooid",
    "common.current": "Huidig",
    "common.locked": "Vergrendeld",
    "common.cancel": "Annuleren",
    "common.backToMap": "Terug naar kaart",
    "common.returnToMap": "Terug naar kaart",
    "common.settings": "Instellingen",
    "common.signOut": "Uitloggen",
    "common.zoomIn": "Inzoomen",
    "common.zoomOut": "Uitzoomen",
    "common.resetView": "Weergave resetten",
    "common.level": "Niveau",
    "brand.fullName": "LOGISTIC INTELLIGENCE NAVIGATOR FOR AI ADOPTION",
    "chat.open": "Chat openen",
    "chat.dragPanel": "Chat slepen",
    "chat.minimize": "Chat minimaliseren",
    "chat.close": "Chat sluiten",
    "chat.statusOnline": "Online",
    "chat.statusOffline": "Offline",
    "chat.goOnline": "Online gaan",
    "chat.goOffline": "Offline gaan",
    "chat.title": "Directe berichten",
    "chat.online": "Online",
    "chat.onlineCount": "Online: {count}",
    "chat.offline": "Offline",
    "chat.statusCount": "{online} online / {offline} offline",
    "chat.userOnline": "{name} is nu online.",
    "chat.newMessageFrom": "Nieuw bericht van {name}: {message}",
    "chat.newMessages": "{count} nieuwe chatberichten.",
    "chat.localOnly":
      "Lokale chatmodus. Pas de chattabellen in backend toe om tussen apparaten te praten.",
    "chat.empty": "Nog geen berichten.",
    "chat.emptyDirect": "Nog geen berichten met deze persoon.",
    "chat.selectPerson": "Kies een persoon",
    "chat.selectPersonDescription": "Selecteer iemand online of offline om een direct gesprek te starten.",
    "chat.selectFirst": "Kies eerst een persoon",
    "chat.placeholder": "Schrijf een bericht...",
    "chat.send": "Versturen",
    "chat.sendError": "Kon het bericht niet versturen.",
    "map.welcome": "Welkom, {name}!",
    "map.explorer": "Ontdekkingsreiziger",
    "map.crew": "Crew",
    "map.globalAdmin": "Globale admin",
    "map.crewAdmin": "Teamadmin",
    "map.selfAssessment": "Zelfevaluatie",
    "map.itemShop": "Eilandwinkel",
    "map.pendingCrewInviteTitle": "Crewuitnodiging wacht",
    "map.pendingCrewInviteDescription":
      "Je hebt {count} open crewuitnodiging. Je hebt 24 uur vanaf het verzenden om te accepteren.",
    "map.newCrewInviteToast":
      "Nieuwe crewuitnodiging! Je hebt 24 uur vanaf het verzenden om te accepteren.",
    "map.reviewCrewInvite": "Bekijk uitnodiging",
    "map.yourJourney": "Jouw reis",
    "map.progress": "Voortgang",
    "map.currentLevel": "Huidig niveau",
    "map.currentLevelDescription": "Niveau {level} van {count}",
    "map.streak": "Reeks",
    "map.streakBonusTotal": "Reeksbonus opgeslagen: +{points} pt",
    "map.streakBonusNext":
      "Houd je reeks op de volgende werkdag vast voor +{points} extra.",
    "streakCelebration.overline": "Welkom terug",
    "streakCelebration.title": "Reeks actief!",
    "streakCelebration.day": "dag",
    "streakCelebration.days": "dagen",
    "streakCelebration.message": "Je dagelijkse reeks blijft branden.",
    "map.islandItems": "Eilanditems",
    "map.nextUpgrade": "Volgende: {label} na {count} voltooide niveaus.",
    "map.legend": "Legenda",
    "map.yourShip": "Jouw schip",
    "map.yourBoat": "Jouw boot",
    "map.yourLorry": "Jouw truck",
    "map.shopTitle": "Eilandwinkel",
    "map.shopDescription":
      "Ontgrendel met niveaus en punten. Kies Toevoegen en klik waar het item moet komen.",
    "map.dragShopPanel": "Sleep winkelpaneel",
    "map.localSaveNotice":
      "Wordt op dit apparaat opgeslagen tot de eilandtabel in backend is toegepast.",
    "map.placedItems": "Geplaatste items",
    "map.noPlacedItems": "Nog geen items geplaatst.",
    "map.unlockRequirement": "Niveau {level} • {points} pt",
    "map.unlockToast":
      "Wordt ontgrendeld op niveau {level} met {points} punten.",
    "map.selected": "Geselecteerd",
    "map.add": "Toevoegen",
    "map.addItem": "Item toevoegen",
    "map.placeItem": "Plek kiezen",
    "map.dragIsland": "Sleep om op de route te verplaatsen.",
    "map.resetIslandLayout": "Eilandindeling resetten",
    "map.resetIslandLayoutSuccess": "Eilandindeling gereset",
    "map.clickMoveItem":
      "Waar wil je het verplaatsen? Klik op een landplek op het eiland.",
    "map.placeInstruction":
      "Waar wil je {label} plaatsen? Klik op een landplek.",
    "map.moveInstruction":
      "Waar wil je {label} verplaatsen? Klik op een landplek.",
    "map.itemFallback": "item",
    "map.mapTitle": "De AI-eilandkaart",
    "map.mapSubtitle": "Volg het pad door {count} niveaus",
    "map.loadError": "Kon eilanden niet laden.",
    "map.signInCustomize": "Log in om je eiland aan te passen.",
    "map.addSuccess": "{label} toegevoegd aan het eiland",
    "map.addLocalInfo":
      "backend heeft de eilandtabel nog niet. Ik heb het voorlopig op dit apparaat opgeslagen.",
    "map.addError": "Kon het item niet toevoegen.",
    "map.moveSuccess": "Item verplaatst",
    "map.moveLocalInfo":
      "Verplaatst op dit apparaat. De backend-migratie moet nog worden toegepast.",
    "map.moveError": "Kon het item niet verplaatsen.",
    "map.removeSuccess": "Item verwijderd van het eiland",
    "map.removeLocalInfo":
      "Verwijderd op dit apparaat. De backend-migratie moet nog worden toegepast.",
    "map.removeError": "Kon het item niet verwijderen.",
    "map.moveItem": "Item verplaatsen",
    "map.deleteItem": "Item verwijderen",
    "map.chooseLand": "Kies een plek op het land van het eiland.",
    "map.completePrevious": "Voltooi eerst het vorige eiland!",
    "map.crewAdvanceBlocked":
      "Je crew gaat samen verder. Iedereen moet eerst het vorige eiland voltooien.",
    "shopItem.campfire-circle.label": "Levend kampvuur",
    "shopItem.campfire-circle.description":
      "Een geanimeerde kampeerplek voor het pad.",
    "shopItem.trail-sign.label": "Padbord",
    "shopItem.trail-sign.description":
      "Markeert paden en prestaties op het eiland.",
    "shopItem.flower-bed.label": "Bloementuin",
    "shopItem.flower-bed.description":
      "Een kleine kleurrijke tuin voor strandranden.",
    "shopItem.river-dock.label": "Riviersteiger",
    "shopItem.river-dock.description":
      "Een kleine houten steiger naast het water.",
    "shopItem.stone-well.label": "Stenen put",
    "shopItem.stone-well.description": "Een rustieke put voor het binnenpad.",
    "shopItem.tulip-garden.label": "Nederlandse tulpen",
    "shopItem.tulip-garden.description":
      "Een compact tulpenbed geinspireerd op Nederland.",
    "shopItem.windmill-hut.label": "Molen",
    "shopItem.windmill-hut.description":
      "Een kleine molen met draaiende wieken.",
    "shopItem.swedish-bridge.label": "Zweedse brug",
    "shopItem.swedish-bridge.description":
      "Een kleine geschilderde brug voor rivieren en paden.",
    "shopItem.colorful-buildings.label": "Kleurige gebouwen",
    "shopItem.colorful-buildings.description":
      "Kleine kleurrijke gebouwen in Zweedse stijl.",
    "shopItem.lighthouse.label": "Vuurtoren",
    "shopItem.lighthouse.description":
      "Een kustlicht dat laat wordt ontgrendeld.",
    "shopItem.orchard-grove.label": "Boomgaard",
    "shopItem.orchard-grove.description":
      "Fruitbomen die het eiland levendiger maken.",
    "shopItem.pier-lantern.label": "Pierlantaarn",
    "shopItem.pier-lantern.description":
      "Een lichtpunt voor plekken dicht bij het water.",
    "shopItem.victory-banner.label": "Vlag",
    "shopItem.victory-banner.description":
      "Een vlag om crewprestaties te markeren.",
    "shopItem.island-fountain.label": "Fontein",
    "shopItem.island-fountain.description":
      "Een decoratieve fontein voor het eilandplein.",
    "shopItem.training-workshop.label": "Werkplaats",
    "shopItem.training-workshop.description":
      "Een kleine werkplaats voor projecten en verbeteringen.",
    "shopItem.stone-gate.label": "Stenen poort",
    "shopItem.stone-gate.description":
      "Een poort die de ingang van het pad benadrukt.",
    "shopItem.treasure-chest.label": "Schatkist",
    "shopItem.treasure-chest.description":
      "Een kist voor beloningen uit het avontuur.",
    "shopItem.learning-library.label": "Bibliotheek",
    "shopItem.learning-library.description":
      "Een kleine bibliotheek voor crewkennis.",
    "shopItem.skill-tower.label": "Toren",
    "shopItem.skill-tower.description":
      "Een hoge toren om de eilandvoortgang te volgen.",
    "shopItem.glass-greenhouse.label": "Kas",
    "shopItem.glass-greenhouse.description":
      "Een glazen kas voor een speciaal groen gebied.",
    "shopItem.observatory-dome.label": "Observatorium",
    "shopItem.observatory-dome.description":
      "Een observatorium om nieuwe eilanden aan de horizon te zien.",
    "shopItem.crew-statue.label": "Standbeeld",
    "shopItem.crew-statue.description":
      "Een standbeeld om ontdekkingsreizigers te vieren.",
    "stage.1": "Basis",
    "stage.2": "Toepassing",
    "stage.3": "Meesterschap",
    "island.notFound": "Eiland niet gevonden",
    "island.stage": "Fase",
    "island.questionShort": "V",
    "island.questionsToPass": "{count} vragen • {points} pt • 70% om te slagen",
    "island.questionsToAdvance":
      "{count} vragen • {points} pt • Scoor 70% of meer om verder te gaan",
    "island.speedBonusHint": "Antwoord sneller voor maximaal +3 bonuspunten.",
    "island.speedBonusEarned": "+{points} snelheidsbonus in {seconds}s",
    "island.beginJourney": "Reis beginnen",
    "island.noQuestions": "Er zijn nog geen vragen voor dit eiland.",
    "island.startStage": "Start fase {stage}",
    "island.submitAnswer": "Antwoord verzenden",
    "island.checking": "Controleren...",
    "island.correct": "Goed!",
    "island.notQuite": "Nog niet helemaal",
    "island.whyRight": "Waarom dit goed is",
    "island.whyWrong": "Waarom dit niet het beste antwoord was",
    "island.yourAnswer": "Jouw antwoord",
    "island.correctAnswer": "Juiste antwoord",
    "island.defaultRight":
      "Dit antwoord past bij de veiligste en meest praktische keuze voor dit scenario.",
    "island.defaultWrong":
      "Bekijk het juiste antwoord en vergelijk het met je keuze.",
    "island.nextQuestion": "Volgende vraag",
    "island.completeStage": "Fase voltooien",
    "island.stageComplete": "Fase {stage} voltooid!",
    "island.stageNotPassed": "Fase {stage} niet gehaald",
    "island.nextChallenge": "Goed gedaan! Klaar voor de volgende uitdaging?",
    "island.islandConqueredStage": "Geweldig! Je hebt dit eiland veroverd!",
    "island.needToAdvance":
      "Je hebt 70% nodig om verder te gaan. Bekijk het en probeer opnieuw!",
    "island.stageScoreLine":
      "{score}/{possible} pt • {correct} van {total} goed",
    "island.progressTitle": "Eilandvoortgang",
    "island.stationCompleteShort": "Voltooid",
    "island.stationAlreadyComplete":
      "Deze stage is al voltooid. Kies een andere.",
    "island.nextStationStage": "Fase {stage} nu",
    "island.backToStations": "Terug naar stages",
    "island.chooseAnotherStation": "Kies een andere stage",
    "island.completeAllStations":
      "Voltooi alle stages op dit eiland voordat je verdergaat.",
    "island.startNextStage": "Start fase {stage}",
    "island.completeIsland": "Eiland voltooien",
    "island.retryStage": "Fase opnieuw proberen",
    "island.conquered": "Eiland veroverd!",
    "island.conqueredSubtitle": "Je beheerst alle 3 fases van {name}!",
    "island.correctOverall":
      "{percent}% • {correct} van {total} goed in totaal",
    "island.playAgain": "Opnieuw spelen",
    "island.loadError": "Kon eilandgegevens niet laden",
    "island.startError": "Kon fase niet starten",
    "island.submitError": "Kon antwoord niet verzenden",
    "settings.title": "Instellingen",
    "settings.profileTitle": "Profielinstellingen",
    "settings.profileDescription": "Pas je ontdekkingsreizigerprofiel aan",
    "settings.avatarUrl": "Avatar-URL",
    "settings.uploadAvatar": "Afbeelding uploaden",
    "settings.uploadingAvatar": "Uploaden...",
    "settings.avatarUploadHint":
      "Kies een JPG, PNG of WebP vanaf dit apparaat.",
    "settings.avatarUploadError":
      "Afbeelding uploaden mislukt. Controleer de storage-instelling.",
    "settings.avatarImageOnly": "Kies een afbeeldingsbestand.",
    "settings.avatarUploadSuccess": "Avatarafbeelding geüpload.",
    "settings.explorerName": "Naam ontdekkingsreiziger",
    "settings.accountEmail": "Account-e-mail",
    "settings.accountEmailDescription":
      "Gebruik deze e-mail om in te loggen en crew-uitnodigingen te ontvangen.",
    "settings.updateEmail": "E-mail bijwerken",
    "settings.emailInvalid": "Voer een geldige e-mail in.",
    "settings.emailUnchanged": "Dit is al je huidige e-mail.",
    "settings.emailUpdateSuccess": "E-mail bijgewerkt.",
    "settings.emailUpdateError": "Kon e-mail niet bijwerken.",
    "settings.emailAlreadyRegistered": "Deze e-mail is al geregistreerd.",
    "settings.profileStatusMessage": "Bericht onder je naam",
    "settings.profileStatusMessagePlaceholder": "Schrijf een welkomstbericht...",
    "settings.hub": "Hub",
    "settings.saveChanges": "Wijzigingen opslaan",
    "settings.updateError": "Kon profiel niet bijwerken",
    "settings.updateSuccess": "Profiel bijgewerkt!",
    "settings.languageTitle": "Speltaal",
    "settings.languageDescription": "Kies de taal voor de game-interface.",
    "settings.dangerTitle": "Gevarenzone",
    "settings.deleteAccount": "Mijn profiel verwijderen",
    "settings.deleteAccountDescription":
      "Dit verwijdert je account, profiel, voortgang, crew-lidmaatschap en sessies permanent. Daarna kun je je opnieuw registreren met hetzelfde e-mailadres.",
    "settings.deleteAccountConfirm":
      'Typ "{phrase}" om je profiel permanent te verwijderen.',
    "settings.deleteAccountConfirmError":
      "Profielverwijdering is niet bevestigd.",
    "settings.deleteAccountSuccess":
      "Profiel verwijderd. Je kunt je opnieuw registreren.",
    "settings.deleteAccountError": "Kon profiel niet verwijderen.",
    "auth.subtitle":
      "Logistics Intelligence Navigator Adventure voor AI-adoptie",
    "auth.title": "Zet koers!",
    "auth.loginDescription":
      "Welkom terug, ontdekkingsreiziger! Ga verder met je avontuur.",
    "auth.signupDescription":
      "Sluit je aan bij de crew en start je AI-leerreis.",
    "auth.login": "Inloggen",
    "auth.signUp": "Registreren",
    "auth.email": "E-mail",
    "auth.password": "Wachtwoord",
    "auth.confirmPassword": "Bevestig wachtwoord",
    "auth.explorerName": "Naam ontdekkingsreiziger",
    "auth.hub": "Hub",
    "auth.chooseHub": "Kies je hub",
    "auth.hubRequired": "Kies je hub om door te gaan.",
    "auth.loggingIn": "Bezig met inloggen...",
    "auth.signingUp": "Je account voorbereiden...",
    "auth.joinAdventure": "Start het avontuur",
    "auth.footer": "Leer AI-concepten via een tropisch avontuur!",
    "auth.invalidCredentials":
      "Ongeldige e-mail of wachtwoord. Probeer opnieuw.",
    "auth.passwordsDoNotMatch": "Wachtwoorden komen niet overeen",
    "auth.emailRegistered":
      "Deze e-mail is al geregistreerd. Probeer in te loggen.",
    "auth.welcomeBack": "Welkom terug, ontdekkingsreiziger!",
    "auth.welcomeAboard": "Welkom aan boord, nieuwe ontdekkingsreiziger!",
    "assessment.title": "Zelfevaluatie",
    "assessment.description":
      "Test je AI-kennis met waar-of-niet-waar vragen. Dit helpt je huidige niveau te begrijpen.",
    "assessment.previousAttempts": "Eerdere pogingen",
    "assessment.completedOnce": "Evaluatie voltooid",
    "assessment.noRetake": "Deze evaluatie kan maar één keer worden voltooid.",
    "assessment.start": "Evaluatie starten",
    "assessment.retake": "Evaluatie opnieuw doen",
    "assessment.retakeShort": "Opnieuw",
    "assessment.questionOf": "Vraag {current} van {total}",
    "assessment.true": "Waar",
    "assessment.false": "Niet waar",
    "assessment.incorrectAnswer": "Onjuist - het antwoord is {answer}",
    "assessment.seeResults": "Resultaten bekijken",
    "assessment.excellent": "Uitstekend!",
    "assessment.goodJob": "Goed gedaan!",
    "assessment.niceTry": "Goede poging!",
    "assessment.keepLearning": "Blijf leren!",
    "assessment.strongFoundation": "Je hebt een sterke basis in AI-kennis!",
    "assessment.rightTrack":
      "Je bent op de goede weg! Blijf de eilanden verkennen om meer te leren.",
    "assessment.buildKnowledge":
      "De eilandavonturen helpen je AI-kennis op te bouwen!",
    "assessment.exploreIslands": "Eilanden verkennen",
    "assessment.loadError": "Kon evaluatie niet laden",
    "assessment.saveError": "Kon je resultaten niet opslaan",
    "assessment.finalTitle": "Laatste herbeoordeling",
    "assessment.finalDescription":
      "Alle eilanden zijn voltooid. Doe deze beoordeling opnieuw en haal minstens {rate}% om voor de overwinning te kwalificeren.",
    "assessment.finalComplete": "Je laatste herbeoordeling is voltooid.",
    "assessment.startFinal": "Laatste herbeoordeling starten",
    "assessment.finalPassedResult":
      "Deze score voldoet aan de overwinningseis.",
    "assessment.finalRetryResult":
      "De overwinningseis is {rate}% of hoger. Je kunt opnieuw proberen zolang je bij de laatste poort bent.",
    "assessment.viewVictory": "Bekijk overwinning",
    "winner.title": "Overwinning",
    "winner.subtitle": "Laatste poort en winnaarverklaring",
    "winner.refresh": "Vernieuwen",
    "winner.loadErrorTitle": "Kon overwinningsgegevens niet laden",
    "winner.declared": "Winnaar uitgeroepen",
    "winner.soloDeclared": "Spelerwinnaar uitgeroepen",
    "winner.declaredOn": "Uitgeroepen op",
    "winner.qualifiedMembers": "Gekwalificeerde leden",
    "winner.islandsEach": "Eilanden per persoon",
    "winner.crewPoints": "Crewpunten",
    "winner.playerPoints": "Spelerpunten",
    "winner.tabs.overview": "Overzicht",
    "winner.tabs.player": "Spelerwinnaar",
    "winner.tabs.crew": "Winnende crew",
    "winner.finalResults": "Resultaten laatste herbeoordeling",
    "winner.noWinnerBadge": "Nog geen winnaar uitgeroepen",
    "winner.waitingTitle": "De laatste poort is nog open.",
    "winner.waitingDescription":
      "Een crew of solospeler wordt pas winnaar wanneer alle vereiste eilanden klaar zijn, de laatste herbeoordeling met {rate}% of hoger is gehaald en elke gekwalificeerde speler de overwinning verklaart.",
    "winner.requirementsTitle": "Overwinningseisen",
    "winner.requirement.validEntry": "Geldige crew of solospeler",
    "winner.requirement.islands": "Voltooi elk vereist eiland",
    "winner.requirement.final": "Haal de laatste herbeoordeling",
    "winner.requirement.declare":
      "Elke gekwalificeerde speler verklaart de overwinning",
    "winner.yourEntry": "Jouw run: {name}",
    "winner.yourCrew": "Jouw crew: {name}",
    "winner.finalReassessment": "Laatste herbeoordeling",
    "winner.finalReassessmentLocked": "Laatste herbeoordeling vergrendeld",
    "winner.finalLockedDescription":
      "Deze wordt ontgrendeld nadat het laatste vereiste eiland is voltooid.",
    "winner.progressTitle": "Voortgang",
    "winner.progressLiveDescription":
      "Live klassement op punten. Uitgeroepen winnaars blijven in de historie terwijl andere crews nog eerste kunnen worden.",
    "winner.progressDescription":
      "Dichtstbijzijnde crews en solospelers op eilandvoortgang en laatste herbeoordeling.",
    "winner.noCrews": "Nog geen crew of solorun heeft voortgang.",
    "winner.members": "{count} leden",
    "winner.solo": "Solo",
    "winner.points": "{points} punten",
    "winner.islands": "Eilanden",
    "winner.finalCheck": "Laatste check",
    "winner.memberIslands": "Eilanden",
    "winner.memberFinal": "Finale",
    "winner.memberDeclaration": "Verklaring",
    "winner.memberStreakBonus": "Reeksbonus",
    "winner.pending": "in afwachting",
    "winner.declaredStatus": "verklaard",
    "winner.notDeclaredStatus": "niet verklaard",
    "winner.declarationOpen":
      "De laatste checks zijn voltooid. Elke gekwalificeerde speler moet de overwinning verklaren.",
    "winner.declareVictory": "Overwinning verklaren",
    "winner.declareLocked": "Laatste poort laadt",
    "winner.declaringVictory": "Verklaren...",
    "winner.declareAlreadyDone": "Overwinning verklaard",
    "winner.declareReadyHint":
      "Alles is klaar. Druk op de kroon en maak deze overwinning officieel.",
    "winner.declareLockedHint":
      "Voltooi de laatste eisen om de overwinningsknop wakker te maken.",
    "winner.declareLockedIslandsHint":
      "Voltooi elk vereist eiland om deze knop op te laden.",
    "winner.declareLockedAssessmentHint":
      "Doe de self assessment opnieuw en haal 90% of meer om de overwinning te ontgrendelen.",
    "winner.declareLockedTeamHint":
      "Wachten tot elke gekwalificeerde speler de laatste herbeoordeling haalt.",
    "winner.declareWaitingTeamHint":
      "Jouw verklaring staat erin. Wanneer iedereen verklaart, wordt deze crew winnaar.",
    "winner.declareWinnerHint":
      "De overwinning is officieel, maar het klassement blijft bewegen.",
    "winner.declareDissolvedHint":
      "Deze winnende crew heeft deze versie voltooid en wacht op de volgende fase.",
    "winner.declareSuccess": "Overwinningsverklaring opgeslagen.",
    "winner.declareLocalSuccess":
      "Verklaring op dit apparaat opgeslagen. Activeer de backendtabel zodat teamgenoten dit kunnen zien.",
    "winner.dissolvesOn": "Crew wordt vrijgegeven op",
    "winner.dissolvedTitle": "Nieuwe eilanden worden nog ontdekt.",
    "winner.dissolvedDescription":
      "Deze winnende crew heeft deze versie van het spel voltooid. Wacht op de volgende versie met binnenkort een nieuwe fase en nieuwe eilanden.",
    "winner.dissolutionNote":
      "Winnende crews worden {days} dagen na de overwinning vrijgegeven zodat de rest van het spel kan doorgaan.",
    "winner.playerWinnerTitle": "Spelerwinnaar",
    "winner.playerWinnerDescriptionSolo":
      "Deze speler voltooide elk eiland en haalde de laatste herbeoordeling.",
    "winner.playerWinnerDescriptionCrew":
      "Hoogste scorer binnen de winnende crew.",
    "winner.noPlayerWinner": "Er is nog geen spelerwinnaar uitgeroepen.",
    "winner.crewRankingTitle": "Score van de winnende crew",
    "winner.noCrewWinner": "Er is nog geen winnende crew uitgeroepen.",
    "winner.soloWinnerNoCrew":
      "Deze overwinning is solo, dus er is geen crewranking.",
    "winner.winnerBadge": "Winnaar",
    "winner.topScorerBadge": "Topscorer",
    "winner.currentUserStatusWinner": "Deze run is uitgeroepen tot winnaar.",
    "winner.currentUserStatusProgress":
      "{percent}% van de eilandvoortgang voltooid.",
    "winner.currentUserStatusNeedsAssessment":
      "Je hebt de laatste poort bereikt. Voltooi de herbeoordeling om te kwalificeren.",
    "winner.currentUserStatusCanDeclare":
      "Je laatste check is goedgekeurd. Verklaar de overwinning om jouw deel af te ronden.",
    "winner.currentUserStatusDeclared":
      "Je hebt de overwinning verklaard. Wachten op de resterende gekwalificeerde spelers.",
    "winner.currentUserStatusWaiting":
      "Wachten tot elke vereiste laatste herbeoordeling is gehaald.",
  },
  sv: {
    "language.label": "Språk",
    "language.en": "Engelska",
    "language.pt": "Portugisiska",
    "language.nl": "Nederländska",
    "language.sv": "Svenska",
    "common.points": "Poäng",
    "common.pointsShort": "p",
    "common.completed": "Klart",
    "common.current": "Aktuell",
    "common.locked": "Låst",
    "common.cancel": "Avbryt",
    "common.backToMap": "Tillbaka till kartan",
    "common.returnToMap": "Tillbaka till kartan",
    "common.settings": "Inställningar",
    "common.signOut": "Logga ut",
    "common.zoomIn": "Zooma in",
    "common.zoomOut": "Zooma ut",
    "common.resetView": "Återställ vy",
    "common.level": "Nivå",
    "brand.fullName": "LOGISTIC INTELLIGENCE NAVIGATOR FOR AI ADOPTION",
    "chat.open": "Oppna chat",
    "chat.dragPanel": "Dra chatten",
    "chat.minimize": "Minimera chatten",
    "chat.close": "Stang chatten",
    "chat.statusOnline": "Online",
    "chat.statusOffline": "Offline",
    "chat.goOnline": "Ga online",
    "chat.goOffline": "Ga offline",
    "chat.title": "Direktmeddelanden",
    "chat.online": "Online",
    "chat.onlineCount": "Online: {count}",
    "chat.offline": "Offline",
    "chat.statusCount": "{online} online / {offline} offline",
    "chat.userOnline": "{name} ar online nu.",
    "chat.newMessageFrom": "Nytt meddelande fran {name}: {message}",
    "chat.newMessages": "{count} nya chattmeddelanden.",
    "chat.localOnly":
      "Lokalt chattlage. Lagg till chattabellerna i backend for samtal mellan enheter.",
    "chat.empty": "Inga meddelanden an.",
    "chat.emptyDirect": "Inga meddelanden med den har personen an.",
    "chat.selectPerson": "Valj en person",
    "chat.selectPersonDescription": "Valj nagon online eller offline for att starta en direkt konversation.",
    "chat.selectFirst": "Valj en person forst",
    "chat.placeholder": "Skriv ett meddelande...",
    "chat.send": "Skicka",
    "chat.sendError": "Kunde inte skicka meddelandet.",
    "map.welcome": "Välkommen, {name}!",
    "map.explorer": "Utforskare",
    "map.crew": "Crew",
    "map.globalAdmin": "Global admin",
    "map.crewAdmin": "Teamadmin",
    "map.selfAssessment": "Självskattning",
    "map.itemShop": "Öbutik",
    "map.pendingCrewInviteTitle": "Crewinbjudan väntar",
    "map.pendingCrewInviteDescription":
      "Du har {count} väntande crewinbjudan. Du har 24 timmar från skickandet på dig att acceptera.",
    "map.newCrewInviteToast":
      "Ny crewinbjudan! Du har 24 timmar från skickandet på dig att acceptera.",
    "map.reviewCrewInvite": "Granska inbjudan",
    "map.yourJourney": "Din resa",
    "map.progress": "Framsteg",
    "map.currentLevel": "Aktuell nivå",
    "map.currentLevelDescription": "Nivå {level} av {count}",
    "map.streak": "Svit",
    "map.streakBonusTotal": "Svitbonus sparad: +{points} poang",
    "map.streakBonusNext":
      "Hall sviten nasta vardag for att lasa upp +{points} till.",
    "streakCelebration.overline": "Valkommen tillbaka",
    "streakCelebration.title": "Sviten lever!",
    "streakCelebration.day": "dag",
    "streakCelebration.days": "dagar",
    "streakCelebration.message": "Din dagliga svit brinner vidare.",
    "map.islandItems": "Öföremål",
    "map.nextUpgrade": "Nästa: {label} efter {count} klara nivåer.",
    "map.legend": "Teckenförklaring",
    "map.yourShip": "Ditt skepp",
    "map.yourBoat": "Din båt",
    "map.yourLorry": "Din lastbil",
    "map.shopTitle": "Öbutik",
    "map.shopDescription":
      "Lås upp med nivåer och poäng. Välj Lägg till och klicka där föremålet ska stå.",
    "map.dragShopPanel": "Dra butikspanel",
    "map.localSaveNotice":
      "Sparas på den här enheten tills ötabellen har lagts in i backend.",
    "map.placedItems": "Placerade föremål",
    "map.noPlacedItems": "Inga föremål placerade än.",
    "map.unlockRequirement": "Nivå {level} • {points} p",
    "map.unlockToast": "Låses upp på nivå {level} med {points} poäng.",
    "map.selected": "Vald",
    "map.add": "Lägg till",
    "map.addItem": "Lagg till foremal",
    "map.placeItem": "Valj plats",
    "map.dragIsland": "Dra for att flytta pa stigen.",
    "map.resetIslandLayout": "Aterstall olayout",
    "map.resetIslandLayoutSuccess": "Olayout aterstalld",
    "map.clickMoveItem":
      "Var vill du flytta det? Klicka på en landplats på ön.",
    "map.placeInstruction":
      "Var vill du placera {label}? Klicka på en landplats.",
    "map.moveInstruction":
      "Var vill du flytta {label}? Klicka på en landplats.",
    "map.itemFallback": "föremål",
    "map.mapTitle": "AI-ökartan",
    "map.mapSubtitle": "Följ stigen genom {count} nivåer",
    "map.loadError": "Kunde inte ladda öarna.",
    "map.signInCustomize": "Logga in för att anpassa din ö.",
    "map.addSuccess": "{label} lades till på ön",
    "map.addLocalInfo":
      "backend har inte ötabellen än. Jag sparade det på den här enheten tills vidare.",
    "map.addError": "Kunde inte lägga till föremålet.",
    "map.moveSuccess": "Föremålet flyttades",
    "map.moveLocalInfo":
      "Flyttat på den här enheten. backend-migreringen behöver fortfarande tillämpas.",
    "map.moveError": "Kunde inte flytta föremålet.",
    "map.removeSuccess": "Föremålet togs bort från ön",
    "map.removeLocalInfo":
      "Borttaget på den här enheten. backend-migreringen behöver fortfarande tillämpas.",
    "map.removeError": "Kunde inte ta bort föremålet.",
    "map.moveItem": "Flytta item",
    "map.deleteItem": "Ta bort item",
    "map.chooseLand": "Välj en plats på öns land.",
    "map.completePrevious": "Slutför den föregående ön först!",
    "map.crewAdvanceBlocked":
      "Din crew går vidare tillsammans. Alla måste slutföra den föregående ön först.",
    "shopItem.campfire-circle.label": "Levande lägereld",
    "shopItem.campfire-circle.description":
      "En animerad lägerplats för stigen.",
    "shopItem.trail-sign.label": "Stigskylt",
    "shopItem.trail-sign.description": "Markerar vägar och framsteg på ön.",
    "shopItem.flower-bed.label": "Blomsterträdgård",
    "shopItem.flower-bed.description":
      "En liten färgrik trädgård vid stranden.",
    "shopItem.river-dock.label": "Flodbrygga",
    "shopItem.river-dock.description": "En liten träbrygga vid vattnet.",
    "shopItem.stone-well.label": "Stenbrunn",
    "shopItem.stone-well.description": "En rustik brunn för den inre stigen.",
    "shopItem.tulip-garden.label": "Nederländska tulpaner",
    "shopItem.tulip-garden.description":
      "En kompakt tulpanrabatt inspirerad av Nederländerna.",
    "shopItem.windmill-hut.label": "Väderkvarn",
    "shopItem.windmill-hut.description":
      "En liten väderkvarn med roterande vingar.",
    "shopItem.swedish-bridge.label": "Svensk bro",
    "shopItem.swedish-bridge.description":
      "En liten målad bro för floder och stigar.",
    "shopItem.colorful-buildings.label": "Färgglada byggnader",
    "shopItem.colorful-buildings.description":
      "Små färgglada byggnader i svensk stil.",
    "shopItem.lighthouse.label": "Fyr",
    "shopItem.lighthouse.description":
      "Ett kustljus som låses upp nära slutet.",
    "shopItem.orchard-grove.label": "Fruktlund",
    "shopItem.orchard-grove.description":
      "Frukttrad som gor on mer levande.",
    "shopItem.pier-lantern.label": "Brygglykta",
    "shopItem.pier-lantern.description":
      "En liten ljuspunkt for omraden nara vattnet.",
    "shopItem.victory-banner.label": "Fana",
    "shopItem.victory-banner.description":
      "En fana for att markera crewens framsteg.",
    "shopItem.island-fountain.label": "Fontan",
    "shopItem.island-fountain.description":
      "En dekorativ fontan for ons torg.",
    "shopItem.training-workshop.label": "Verkstad",
    "shopItem.training-workshop.description":
      "En liten verkstad for projekt och forbattrningar.",
    "shopItem.stone-gate.label": "Stenport",
    "shopItem.stone-gate.description":
      "En port som markerar stigentrens ingang.",
    "shopItem.treasure-chest.label": "Skattkista",
    "shopItem.treasure-chest.description":
      "En kista for aventyrsbeloningar.",
    "shopItem.learning-library.label": "Bibliotek",
    "shopItem.learning-library.description":
      "Ett litet bibliotek for crewens kunskap.",
    "shopItem.skill-tower.label": "Torn",
    "shopItem.skill-tower.description":
      "Ett hogt torn for att folja ons framsteg.",
    "shopItem.glass-greenhouse.label": "Vaxthus",
    "shopItem.glass-greenhouse.description":
      "Ett glasvaxthus for ett sarskilt gront omrade.",
    "shopItem.observatory-dome.label": "Observatorium",
    "shopItem.observatory-dome.description":
      "Ett observatorium for att se nya oar vid horisonten.",
    "shopItem.crew-statue.label": "Staty",
    "shopItem.crew-statue.description":
      "En staty for att fira utforskarna.",
    "stage.1": "Grunder",
    "stage.2": "Tillämpning",
    "stage.3": "Mästerskap",
    "island.notFound": "Ön hittades inte",
    "island.stage": "Etapp",
    "island.questionShort": "F",
    "island.questionsToPass": "{count} frågor • {points} p • 70% för att klara",
    "island.questionsToAdvance":
      "{count} frågor • {points} p • Få 70% eller mer för att gå vidare",
    "island.speedBonusHint": "Svara snabbare för upp till +3 bonuspoäng.",
    "island.speedBonusEarned": "+{points} snabbhetsbonus på {seconds}s",
    "island.beginJourney": "Börja resan",
    "island.noQuestions": "Det finns inga frågor för den här ön än.",
    "island.startStage": "Starta etapp {stage}",
    "island.submitAnswer": "Skicka svar",
    "island.checking": "Kontrollerar...",
    "island.correct": "Rätt!",
    "island.notQuite": "Inte riktigt",
    "island.whyRight": "Varför detta är rätt",
    "island.whyWrong": "Varför detta inte var det bästa svaret",
    "island.yourAnswer": "Ditt svar",
    "island.correctAnswer": "Rätt svar",
    "island.defaultRight":
      "Det här svaret matchar det säkraste och mest praktiska valet för scenariot.",
    "island.defaultWrong":
      "Gå igenom det rätta svaret och jämför det med ditt val.",
    "island.nextQuestion": "Nästa fråga",
    "island.completeStage": "Slutför etapp",
    "island.stageComplete": "Etapp {stage} klar!",
    "island.stageNotPassed": "Etapp {stage} ej klar",
    "island.nextChallenge": "Bra jobbat! Redo för nästa utmaning?",
    "island.islandConqueredStage": "Fantastiskt! Du har erövrat den här ön!",
    "island.needToAdvance":
      "Du behöver 70% för att gå vidare. Gå igenom och försök igen!",
    "island.stageScoreLine": "{score}/{possible} p • {correct} av {total} rätt",
    "island.progressTitle": "Öframsteg",
    "island.stationCompleteShort": "Slutförd",
    "island.stationAlreadyComplete":
      "Den här nivån är redan slutförd. Välj en annan.",
    "island.nextStationStage": "Etapp {stage} nu",
    "island.backToStations": "Tillbaka till stages",
    "island.chooseAnotherStation": "Välj en annan stage",
    "island.completeAllStations":
      "Slutför alla stages på ön innan du går vidare.",
    "island.startNextStage": "Starta etapp {stage}",
    "island.completeIsland": "Slutför ön",
    "island.retryStage": "Försök igen",
    "island.conquered": "Ön erövrad!",
    "island.conqueredSubtitle": "Du behärskar alla 3 etapper på {name}!",
    "island.correctOverall": "{percent}% • {correct} av {total} rätt totalt",
    "island.playAgain": "Spela igen",
    "island.loadError": "Kunde inte ladda ödata",
    "island.startError": "Kunde inte starta etappen",
    "island.submitError": "Kunde inte skicka svaret",
    "settings.title": "Inställningar",
    "settings.profileTitle": "Profilinställningar",
    "settings.profileDescription": "Anpassa din utforskarprofil",
    "settings.avatarUrl": "Avatar-URL",
    "settings.uploadAvatar": "Ladda upp bild",
    "settings.uploadingAvatar": "Laddar upp...",
    "settings.avatarUploadHint":
      "Välj en JPG, PNG eller WebP från den här enheten.",
    "settings.avatarUploadError":
      "Kunde inte ladda upp bilden. Kontrollera storage-inställningen.",
    "settings.avatarImageOnly": "Välj en bildfil.",
    "settings.avatarUploadSuccess": "Avatarbilden laddades upp.",
    "settings.explorerName": "Utforskarnamn",
    "settings.accountEmail": "Konto-e-post",
    "settings.accountEmailDescription":
      "Anvand denna e-post for inloggning och crew-inbjudningar.",
    "settings.updateEmail": "Uppdatera e-post",
    "settings.emailInvalid": "Ange en giltig e-post.",
    "settings.emailUnchanged": "Detta ar redan din aktuella e-post.",
    "settings.emailUpdateSuccess": "E-post uppdaterad.",
    "settings.emailUpdateError": "Kunde inte uppdatera e-post.",
    "settings.emailAlreadyRegistered": "Denna e-post ar redan registrerad.",
    "settings.profileStatusMessage": "Meddelande under ditt namn",
    "settings.profileStatusMessagePlaceholder":
      "Skriv ett valkomstmeddelande...",
    "settings.hub": "Hub",
    "settings.saveChanges": "Spara ändringar",
    "settings.updateError": "Kunde inte uppdatera profilen",
    "settings.updateSuccess": "Profilen uppdaterades!",
    "settings.languageTitle": "Spelspråk",
    "settings.languageDescription": "Välj språk för spelgränssnittet.",
    "settings.dangerTitle": "Riskzon",
    "settings.deleteAccount": "Ta bort min profil",
    "settings.deleteAccountDescription":
      "Detta tar permanent bort ditt konto, din profil, dina framsteg, crew-medlemskap och sessioner. Sedan kan du registrera dig igen med samma e-post.",
    "settings.deleteAccountConfirm":
      'Skriv "{phrase}" for att ta bort din profil permanent.',
    "settings.deleteAccountConfirmError": "Profilborttagning bekraftades inte.",
    "settings.deleteAccountSuccess":
      "Profilen togs bort. Du kan registrera dig igen.",
    "settings.deleteAccountError": "Kunde inte ta bort profilen.",
    "auth.subtitle":
      "Logistics Intelligence Navigator Adventure för AI-adoption",
    "auth.title": "Ge dig av!",
    "auth.loginDescription":
      "Välkommen tillbaka, utforskare! Fortsätt ditt äventyr.",
    "auth.signupDescription":
      "Gå med i besättningen och starta din AI-lärresa.",
    "auth.login": "Logga in",
    "auth.signUp": "Skapa konto",
    "auth.email": "E-post",
    "auth.password": "Lösenord",
    "auth.confirmPassword": "Bekräfta lösenord",
    "auth.explorerName": "Utforskarnamn",
    "auth.hub": "Hub",
    "auth.chooseHub": "Välj din hub",
    "auth.hubRequired": "Välj din hub för att fortsätta.",
    "auth.loggingIn": "Loggar in...",
    "auth.signingUp": "Förbereder ditt konto...",
    "auth.joinAdventure": "Starta äventyret",
    "auth.footer": "Lär dig AI-koncept genom ett tropiskt äventyr!",
    "auth.invalidCredentials": "Ogiltig e-post eller lösenord. Försök igen.",
    "auth.passwordsDoNotMatch": "Lösenorden matchar inte",
    "auth.emailRegistered":
      "Den här e-posten är redan registrerad. Prova att logga in.",
    "auth.welcomeBack": "Välkommen tillbaka, utforskare!",
    "auth.welcomeAboard": "Välkommen ombord, nya utforskare!",
    "assessment.title": "Självskattning",
    "assessment.description":
      "Testa din AI-kunskap med sant eller falskt-frågor. Det hjälper dig att förstå din aktuella nivå.",
    "assessment.previousAttempts": "Tidigare försök",
    "assessment.completedOnce": "Skattning slutförd",
    "assessment.noRetake": "Den här skattningen kan bara göras en gång.",
    "assessment.start": "Starta skattning",
    "assessment.retake": "Gör skattningen igen",
    "assessment.retakeShort": "Gör om",
    "assessment.questionOf": "Fråga {current} av {total}",
    "assessment.true": "Sant",
    "assessment.false": "Falskt",
    "assessment.incorrectAnswer": "Fel - svaret är {answer}",
    "assessment.seeResults": "Se resultat",
    "assessment.excellent": "Utmärkt!",
    "assessment.goodJob": "Bra jobbat!",
    "assessment.niceTry": "Bra försök!",
    "assessment.keepLearning": "Fortsätt lära!",
    "assessment.strongFoundation": "Du har en stark grund i AI-kunskap!",
    "assessment.rightTrack":
      "Du är på rätt väg! Fortsätt utforska öarna för att lära dig mer.",
    "assessment.buildKnowledge":
      "Öäventyren hjälper dig att bygga din AI-kunskap!",
    "assessment.exploreIslands": "Utforska öar",
    "assessment.loadError": "Kunde inte ladda skattningen",
    "assessment.saveError": "Kunde inte spara dina resultat",
    "assessment.finalTitle": "Slutlig självskattning",
    "assessment.finalDescription":
      "Alla öar är slutförda. Gör om skattningen och få minst {rate}% för att kvalificera dig för seger.",
    "assessment.finalComplete": "Din slutliga självskattning är klar.",
    "assessment.startFinal": "Starta slutlig självskattning",
    "assessment.finalPassedResult": "Den här poängen uppfyller segerkravet.",
    "assessment.finalRetryResult":
      "Segerkravet är {rate}% eller mer. Du kan försöka igen medan du är vid slutporten.",
    "assessment.viewVictory": "Visa seger",
    "winner.title": "Seger",
    "winner.subtitle": "Slutport och vinnarbesked",
    "winner.refresh": "Uppdatera",
    "winner.loadErrorTitle": "Kunde inte ladda segerdata",
    "winner.declared": "Vinnare utsedd",
    "winner.soloDeclared": "Spelarvinnare utsedd",
    "winner.declaredOn": "Utsedd den",
    "winner.qualifiedMembers": "Kvalificerade medlemmar",
    "winner.islandsEach": "Öar per person",
    "winner.crewPoints": "Crewpoäng",
    "winner.playerPoints": "Spelarpoäng",
    "winner.tabs.overview": "Översikt",
    "winner.tabs.player": "Spelarvinnare",
    "winner.tabs.crew": "Vinnande crew",
    "winner.finalResults": "Resultat från slutlig självskattning",
    "winner.noWinnerBadge": "Ingen vinnare utsedd än",
    "winner.waitingTitle": "Slutporten är fortfarande öppen.",
    "winner.waitingDescription":
      "En crew eller solospelare utses först när alla nödvändiga öar är klara, den slutliga självskattningen klaras med {rate}% eller mer och varje kvalificerad spelare deklarerar seger.",
    "winner.requirementsTitle": "Segerkrav",
    "winner.requirement.validEntry": "Giltig crew eller solospelare",
    "winner.requirement.islands": "Slutför varje nödvändig ö",
    "winner.requirement.final": "Klara den slutliga självskattningen",
    "winner.requirement.declare": "Varje kvalificerad spelare deklarerar seger",
    "winner.yourEntry": "Din runda: {name}",
    "winner.yourCrew": "Din crew: {name}",
    "winner.finalReassessment": "Slutlig självskattning",
    "winner.finalReassessmentLocked": "Slutlig självskattning låst",
    "winner.finalLockedDescription":
      "Den låses upp när den sista nödvändiga ön är klar.",
    "winner.progressTitle": "Framsteg",
    "winner.progressLiveDescription":
      "Live ranking efter poang. Utsedda vinnare stannar i historiken medan andra crews fortfarande kan ta forsta platsen.",
    "winner.progressDescription":
      "Närmsta crews och solospelare efter öframsteg och slutlig självskattning.",
    "winner.noCrews": "Ingen crew eller solorunda har framsteg än.",
    "winner.members": "{count} medlemmar",
    "winner.solo": "Solo",
    "winner.points": "{points} poäng",
    "winner.islands": "Öar",
    "winner.finalCheck": "Slutkontroll",
    "winner.memberIslands": "Öar",
    "winner.memberFinal": "Final",
    "winner.memberDeclaration": "Deklaration",
    "winner.memberStreakBonus": "Svitbonus",
    "winner.pending": "väntar",
    "winner.declaredStatus": "deklarerad",
    "winner.notDeclaredStatus": "inte deklarerad",
    "winner.declarationOpen":
      "Slutkontrollerna är klara. Varje kvalificerad spelare måste deklarera seger.",
    "winner.declareVictory": "Deklarera seger",
    "winner.declareLocked": "Slutporten laddar",
    "winner.declaringVictory": "Deklarerar...",
    "winner.declareAlreadyDone": "Seger deklarerad",
    "winner.declareReadyHint":
      "Allt ar klart. Tryck pa kronan och gor segern officiell.",
    "winner.declareLockedHint":
      "Slutfor de sista kraven for att vacka segerknappen.",
    "winner.declareLockedIslandsHint":
      "Slutfor varje nodvandig o for att ladda den har knappen.",
    "winner.declareLockedAssessmentHint":
      "Gor om self assessment och fa 90% eller mer for att lasa upp segern.",
    "winner.declareLockedTeamHint":
      "Vantar pa att varje kvalificerad spelare klarar slutbedomningen.",
    "winner.declareWaitingTeamHint":
      "Din deklaration ar inne. Nar alla deklarerar blir denna crew vinnare.",
    "winner.declareWinnerHint":
      "Segern ar officiell, men topplistan fortsatter rora sig.",
    "winner.declareDissolvedHint":
      "Den har vinnande crewn har klarat denna version och vantar pa nasta fas.",
    "winner.declareSuccess": "Segerdeklarationen sparades.",
    "winner.declareLocalSuccess":
      "Deklarationen sparades på den här enheten. Aktivera backendtabellen så att lagkamrater kan se den.",
    "winner.dissolvesOn": "Crewn släpps den",
    "winner.dissolvedTitle": "Nya öar håller fortfarande på att upptäckas.",
    "winner.dissolvedDescription":
      "Den här vinnande crewn har slutfört den här versionen av spelet. Vänta på nästa version med en ny fas och nya öar snart.",
    "winner.dissolutionNote":
      "Vinnande crews släpps {days} dagar efter segern så att resten av spelet kan fortsätta.",
    "winner.playerWinnerTitle": "Spelarvinnare",
    "winner.playerWinnerDescriptionSolo":
      "Den här spelaren slutförde alla öar och klarade den slutliga självskattningen.",
    "winner.playerWinnerDescriptionCrew":
      "Högsta poängen inom den vinnande crewn.",
    "winner.noPlayerWinner": "Ingen spelarvinnare har utsetts än.",
    "winner.crewRankingTitle": "Poäng i vinnande crew",
    "winner.noCrewWinner": "Ingen vinnande crew har utsetts än.",
    "winner.soloWinnerNoCrew":
      "Den här segern är solo, så det finns ingen crewranking.",
    "winner.winnerBadge": "Vinnare",
    "winner.topScorerBadge": "Toppscorer",
    "winner.currentUserStatusWinner":
      "Den här rundan har utsetts till vinnare.",
    "winner.currentUserStatusProgress": "{percent}% av öframstegen klara.",
    "winner.currentUserStatusNeedsAssessment":
      "Du har nått slutporten. Slutför självskattningen för att kvalificera dig.",
    "winner.currentUserStatusCanDeclare":
      "Din slutkontroll är godkänd. Deklarera seger för att avsluta din del.",
    "winner.currentUserStatusDeclared":
      "Du har deklarerat seger. Väntar på resterande kvalificerade spelare.",
    "winner.currentUserStatusWaiting":
      "Väntar på att varje nödvändig slutlig självskattning ska klaras.",
  },
} as const;

export type TranslationKey = keyof typeof translations.en;
